import { checkTocToken, parseJson } from "./utils";
function validuser() {
  const city = parseJson(window.localStorage.getItem("TOCCITY"));
  const token = parseJson(window.localStorage.getItem("TOCTOKEN"));
  if (!(city && city.CityFlag) || !token || !checkTocToken(token)) {
    return false;
  } else {
    return true;
  }
}

export { validuser };
